<template>
    <div>
        <div class="font-bold text-center text-[20px]">Công cụ</div>
        <div class="grid grid-cols-2 gap-4 my-4">
            <div>
                <button class="bg-green-500 text-white text-center w-full rounded-md p-4 font-bold"><font-awesome-icon :icon="['fas', 'file-excel']" /> Nhập Excel</button>
            </div>
            <div>
                <button class="bg-green-500 text-white text-center w-full rounded-md p-4 font-bold"><font-awesome-icon :icon="['fas', 'lock']" /> Khóa sổ thu chi</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>